import styled from 'styled-components';
import type { BreadcrumbNode } from '@amplience/content-types/typings/h-breadcrumb-node';
import { maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';
import { ContentBreadcrumbNode } from './ContentBreadcrumbNode';

export type BreadcrumbDataType = {
  content: BreadcrumbNode;
};

type ContentBreadcrumbProps = {
  breadcrumbData: BreadcrumbDataType[];
  horizontalPadding?: boolean;
};

const S = {
  Breadcrumb: styled.nav<{ $horizontalPadding: boolean }>`
    display: none;

    @media ${media.greaterThan('lg')} {
      display: block;
      margin: ${spacing.M} 0 ${spacing.L};

      > ol {
        ${maxWidthPartial({ withPaddingXL: true })}
        display: flex;
        gap: ${spacing.XS};
      }

      ol {
        ${({ $horizontalPadding }) => !$horizontalPadding && 'padding: 0'}
      }
    }
  `,
};

export function ContentBreadcrumb({ breadcrumbData, horizontalPadding = true }: ContentBreadcrumbProps) {
  return (
    <S.Breadcrumb $horizontalPadding={horizontalPadding}>
      <ol>
        {breadcrumbData?.map((item, index) => (
          <ContentBreadcrumbNode {...item.content} key={`breadcrumb-${index}`} />
        ))}
      </ol>
    </S.Breadcrumb>
  );
}
